module.exports = __webpack_public_path__ + "static/img/wx_qrcode.7176552c.jpg";